/* global axios */
import ApiClient from '../ApiClient';

class FBChannel extends ApiClient {
  constructor() {
    super('facebook', { accountScoped: true });
  }

  create(params) {
    return axios.post(`${this.url}/connections/register_facebook_page`, params);
  }

  generateAuthorization(params) {
    return axios.post(`${this.url}/authorization`, { authorization: params });
  }

  // Fetch available Facebook pages via GET using state query param
  fetchPages(params = {}) {
    return axios.get(`${this.url}/connections/facebook_pages`, { params });
  }
}

export default new FBChannel();
